<template>
  <div>
    <el-table id="codingLargeStatPsi" :data="dashboardData.length ? dashboardData[0].largeStats[8].data : []" empty-text="No PSI Data Available" :fit="true"
      :height="isModal ? null : '300'" show-summary :summary-method="getSummary">
      <el-table-column prop="shortDescription" label="Indicator" sortable show-overflow-tooltip width="75">
        <template slot-scope="props">
          <a :href="props.row.href" target="_blank">{{props.row.shortDescription}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="longDescription" label="Description" sortable>
      </el-table-column>
      <el-table-column prop="psiCount" label="Total Records" width="100" sortable align="center">
        <template slot-scope="scope">
          <div class="dottedUnderline" ref="" @click="emitDetailsEvent(`${scope.row.shortDescription} Records`, scope.row.accounts, $event)">
            {{scope.row.psiCount}}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import money from '@/mixins/money'

  export default {
    props: ['dashboardData'],
    mixins: [money],
    components: {
    },
    data: function () {
      return {
      }
    },
    name: 'PatientSafetyIndicatorsTable',
    methods: {
      moneyFormatter(row, column) {
        return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
      },
      emitDetailsEvent(title, accounts, e) {
        this.$emit('detailsClick', {
          title: title,
          accounts: accounts,
          e: e
        })
      },
      totalSummary(column, data) {
        let response = data.reduce((total, curr) => {
          const value = Number(curr[column])
          if (!isNaN(value)) {
            return total + value
          } else {
            return total
          }
        }, 0)

        return response
      },
      getSummary(param) {
        const psiCount = this.totalSummary('psiCount', param.data)
        return [null, null, psiCount]
      }
    },
    created: function () {
    },
    mounted: function () {
      this.$nextTick(() => {
        const footerRow = document.querySelectorAll('#codingLargeStatPsi table.el-table__footer td')
        const td = footerRow[footerRow.length - 1]
        td.classList.add('dottedUnderline')
        td.addEventListener('click', (e) => {
          const allAccounts = this.dashboardData[0].largeStats[8].data.map(x => x.accounts).join(',')
          this.emitDetailsEvent('All PSI Records', allAccounts, e)
        })
      })
    },
    computed: {
      isModal() {
        return this.$parent.modal
      }
    }
  }
</script>
